export default __webpack_public_path__ + "static/media/timelineIcon.902a70d1.svg";